import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

type LogoKey =
	| 'LOGO-AURA-VERTICAL-WHITE1'
	| 'LOGO-INNOVA-COLOR-WHITE2'
	| 'LOGO-INNOVA-VERTICAL-WHITE1';

const LOCALIZED_LOGOS: LogoKey[] = [
	'LOGO-AURA-VERTICAL-WHITE1',
	'LOGO-INNOVA-COLOR-WHITE2',
	'LOGO-INNOVA-VERTICAL-WHITE1',
];

@Injectable({ providedIn: 'root' })
export class LogoService {
	constructor(private translocoService: TranslocoService) {}

	getLogoPath(key: LogoKey): Observable<string> {
		return this.translocoService.langChanges$.pipe(
			startWith(this.translocoService.getActiveLang()),
			map(lang => this.resolveLogoPath(key, lang))
		);
	}

	resolveLogoPath(key: LogoKey, lang?: string): string {
		const activeLang = lang ?? this.translocoService.getActiveLang();
		const suffix = activeLang === 'br' && LOCALIZED_LOGOS.includes(key) ? '-BR' : '';
		return `assets/images/logo/${key}${suffix}.png`;
	}
}
